import { render } from "./Features.vue?vue&type=template&id=04e40432"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
script.render = render

export default script